module.exports = "/img/_/_/_/assets/images/creeper/book/common//16.jpg?dfb04af876ac9d6bb5fc1d297d5a4223";